import { componentCls } from "@faire/slate/lib/tracking";
import { tsv } from "@faire/slate/lib/tsv";
import { BadgeBase } from "@faire/slate/private/badge/BadgeBase";
import { BadgeContent } from "@faire/slate/private/badge/BadgeContent";
import { BadgeVariant } from "@faire/slate/private/badge/types";
import { IWebComponentProps } from "@faire/slate/private/shared/types";
import React from "react";

type IProps = {
  /**
   * When `true` displays the exact value, otherwise when `false` values above `99` are displayed as `99+`.
   *
   * @default false
   */
  showExact?: boolean;

  /**
   * The tag label.
   */
  value: number;

  /**
   * The variant of the badge.
   *
   * @default "default"
   */
  variant?: BadgeVariant;

  // DO NOT ADD any new prop without aligning with Slate team first
} & IWebComponentProps;

/**
 * Badges display a numeric value in a pill-shaped container.
 *
 * See [migration guide](migration-guide.mdx) for more information.
 *
 * {@link https://www.notion.so/faire/Badge-2242efb5c25a8047a11fd4b935974d52 | Slate/Badge}
 */
export const Badge: React.FC<IProps> = ({
  showExact = false,
  value,
  variant = "default",
  ...props
}) => (
  <BadgeBase
    {...props}
    className={componentCls(badgeStyle.cls({ variant }))}
    data-component-name="Slate/Badge"
  >
    <BadgeContent showExact={showExact}>{value}</BadgeContent>
  </BadgeBase>
);

const badgeStyle = tsv({
  variants: {
    variant: {
      default: "",
      inverse: "fs-badge--inverse",
    },
  },
});
